/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The DashboardsurgeriesReadinessRisk model module.
 * @module model/DashboardsurgeriesReadinessRisk
 * @version v0.3
 */
export default class DashboardsurgeriesReadinessRisk {
  /**
   * Constructs a new <code>DashboardsurgeriesReadinessRisk</code>.
   * @alias module:model/DashboardsurgeriesReadinessRisk
   * @class
   * @param level {module:model/DashboardsurgeriesReadinessRisk.LevelEnum}
   * @param basis {module:model/DashboardsurgeriesReadinessRisk.BasisEnum}
   * @param remainingGoals {Number}
   * @param totalGoals {Number}
   * @param daysToSurgery {Number}
   * @param reasons {Array.<String>}
   * @param version {String}
   */
  constructor(level, basis, remainingGoals, totalGoals, daysToSurgery, reasons, version) {
    this.level = level;
    this.basis = basis;
    this.remainingGoals = remainingGoals;
    this.totalGoals = totalGoals;
    this.daysToSurgery = daysToSurgery;
    this.reasons = reasons;
    this.version = version;
  }

  /**
   * Constructs a <code>DashboardsurgeriesReadinessRisk</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardsurgeriesReadinessRisk} obj Optional instance to populate.
   * @return {module:model/DashboardsurgeriesReadinessRisk} The populated <code>DashboardsurgeriesReadinessRisk</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DashboardsurgeriesReadinessRisk();
      if (data.hasOwnProperty('level'))
        obj.level = ApiClient.convertToType(data['level'], 'String');
      if (data.hasOwnProperty('basis'))
        obj.basis = ApiClient.convertToType(data['basis'], 'String');
      if (data.hasOwnProperty('remaining_goals'))
        obj.remainingGoals = ApiClient.convertToType(data['remaining_goals'], 'Number');
      if (data.hasOwnProperty('total_goals'))
        obj.totalGoals = ApiClient.convertToType(data['total_goals'], 'Number');
      if (data.hasOwnProperty('days_to_surgery'))
        obj.daysToSurgery = ApiClient.convertToType(data['days_to_surgery'], 'Number');
      if (data.hasOwnProperty('reasons'))
        obj.reasons = ApiClient.convertToType(data['reasons'], ['String']);
      if (data.hasOwnProperty('version'))
        obj.version = ApiClient.convertToType(data['version'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>level</code> property.
 * @enum {String}
 * @readonly
 */
DashboardsurgeriesReadinessRisk.LevelEnum = {
  /**
   * value: "low"
   * @const
   */
  low: "low",

  /**
   * value: "medium"
   * @const
   */
  medium: "medium",

  /**
   * value: "high"
   * @const
   */
  high: "high",

  /**
   * value: "no_surgery_date"
   * @const
   */
  noSurgeryDate: "no_surgery_date",

  /**
   * value: "surgery_past"
   * @const
   */
  surgeryPast: "surgery_past"
};
/**
 * @member {module:model/DashboardsurgeriesReadinessRisk.LevelEnum} level
 */
DashboardsurgeriesReadinessRisk.prototype.level = undefined;

/**
 * Allowed values for the <code>basis</code> property.
 * @enum {String}
 * @readonly
 */
DashboardsurgeriesReadinessRisk.BasisEnum = {
  /**
   * value: "clearance"
   * @const
   */
  clearance: "clearance",

  /**
   * value: "final_preparation"
   * @const
   */
  finalPreparation: "final_preparation"
};
/**
 * @member {module:model/DashboardsurgeriesReadinessRisk.BasisEnum} basis
 */
DashboardsurgeriesReadinessRisk.prototype.basis = undefined;

/**
 * @member {Number} remainingGoals
 */
DashboardsurgeriesReadinessRisk.prototype.remainingGoals = undefined;

/**
 * @member {Number} totalGoals
 */
DashboardsurgeriesReadinessRisk.prototype.totalGoals = undefined;

/**
 * @member {Number} daysToSurgery
 */
DashboardsurgeriesReadinessRisk.prototype.daysToSurgery = undefined;

/**
 * @member {Array.<String>} reasons
 */
DashboardsurgeriesReadinessRisk.prototype.reasons = undefined;

/**
 * @member {String} version
 */
DashboardsurgeriesReadinessRisk.prototype.version = undefined;
